<div class="bank-div bank-details">
  <div class="col-md-12 head-div">Bank Details</div>
  <div class="stripe-div" *ngIf="!detailsAvailable">
    <button type="submit" class="stripe-btn" (click)="toggleInfoDiv()">
      Connect To Stripe
    </button>
  </div>
  <div class="info-div" *ngIf="detailsAvailable">
    <!-- <div class="info-div" [style.display]="infoDivVisible ? 'block' : 'none'"> -->
    <div class="content-div">
      <form [formGroup]="bankForm">
        <div class="edit-btn">
          <mat-form-field>
            <input matInput readonly type="text" [placeholder]="bankForm?.value.bankName ? '' : 'Enter bank name'" formControlName="bankName" />
          </mat-form-field>
          <!-- <div>
            <img
              class="circle-png"
              src="../../../assets/icons/edit-circle.png"
              alt="invalid"
            />
          </div> -->
        </div>
        <mat-form-field>
          <input
            matInput readonly
            type="text"
            [placeholder]="bankForm?.value.name ? '' : accountHolderName"
            formControlName="name"
          />
        </mat-form-field>
        <mat-form-field>
          <input matInput readonly type="text" [placeholder]="bankForm?.value.accountNumber ? '' : 'Enter account number'" formControlName="accountNumber" />
        </mat-form-field>
      </form>
    </div>
  </div>
  <div style="float: right;" class="fullwidthmob" *ngIf="detailsAvailable">
    <!-- [style.display]="infoDivVisible ? 'block' : 'none'" -->
    <button type="submit" class="btn-div" (click)="onUnlinkClink()">
      Unlink Stripe Account
    </button>
  </div>
</div>
